import EmergencyBanner from './EmergencyBanner'
export type { EmergencyBannerProps } from './EmergencyBanner'
export default EmergencyBanner
